Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'x-pd-reviews-summary', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-pd-reviews-summary', $context),
            model = null, literals = null, isInitialCall = true;

        if ($control.length < 1) return;

        control = $control.get(0);

        control.bind = function () {
            //initialize stars
            if ($('.x-review-stars[data-type="stars"]', $control).length > 0) {
                $('.x-review-stars[data-type="stars"]', $control).each(function (i, wrapper) {

                    var $wrapper = $(wrapper);

                    var isRateMode = $wrapper.data('is-rate-mode');
                    var ratingSummaryData = $wrapper.data('rating-summary');
                    var ratingSummary = 0.00;

                    if (typeof ratingSummaryData === 'string') {
                        ratingSummary = parseFloat(ratingSummaryData.replace(",", "."));
                    } else if (typeof ratingSummaryData === 'number') {
                        ratingSummary = parseFloat(ratingSummaryData);
                    }

                    initStars(isRateMode, ratingSummary, $wrapper);
                });
            }

            //scroll to reviews
            if ($('.js-scroll-to-reviews', $control).length > 0) {
                $('.js-scroll-to-reviews', $control).click(function () {
                    scrollOffset = $(window).outerWidth() > 960 ? 100 : 50;
                    $('.product-details-region .x-pd-tab-panel .tab-title.reviews .mb-title').trigger('click');
                    $('html, body').animate({ scrollTop: $('.product-details-region .x-pd-tab-panel .tab-content.reviews').offset().top - scrollOffset }, 1);
                });
            }
            
            //scroll to review form and open it
            if ($('.js-scroll-to-review-form', $control).length > 0) {
                $('.js-scroll-to-review-form', $control).click(function () {
                    scrollOffset = $(window).outerWidth() > 960 ? 100 : 50;
                    $('.product-details-region .x-pd-tab-panel .tab-title.reviews .mb-title').trigger('click');
                    $('html, body').animate({ scrollTop: $('.product-details-region .x-pd-tab-panel .tab-content.reviews').offset().top - scrollOffset }, 1);
                    $('[data-click="open-product-review-form"]').trigger('click');
                });
            }
            
        };

        control.update = function () {

            var html = Vendd.Handlebars.parse("pdReviewsSummary_A", model);

            $control.html(html);

            control.bind();
        };

        control.bind();

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetReviewsSuccess, control, function (envelope) {
            if (isInitialCall) {
                model = envelope.message.data.Data;
                literals = envelope.message.data.Text;

                //extend model                      
                model = { ...model, ...literals };
                model.Stars.Enabled = false;

                //update
                control.update();

                isInitialCall = false;
            }
        }); 

    });

});